<template>
  <div>
    <BaseButton tag="RouterLink" primary small class="flex items-center" :to="funnelViewRoute">
      <span>View</span>
    </BaseButton>
  </div>
</template>

<script>
import { funnelsClient } from '@/api/clients';

export default {
  props: {
    funnel: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    funnelViewRoute() {
      return {
        name: 'accounts.accountId.funnels.funnelId',
        params: {
          accountId: this.funnel.account_id,
          funnelId: this.funnel.id,
        },
      };
    },
  },
  methods: {
    async updateFunnel(data) {
      try {
        const response = await funnelsClient.update(this.funnel.id, data);

        this.onUpdated(response.data);

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    editFunnel() {
      this.$modal.show({
        component: () => import('Components/Funnel/FunnelModal.vue'),
        props: {
          action: this.updateFunnel,
          defaultData: {
            id: this.funnel.id,
            name: this.funnel.name || '',
            description: this.funnel.description || '',
            source: 'facebook',
            facebook_ad_account_id: this.funnel.model.facebook_account_id,
            facebook_funnel_type: this.funnel.model_type,
            facebook_funnel_id: this.funnel.model_id,
          },
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
